document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector("#MineBoxDrawer");
  if (!drawer) return;

  const openButtons = document.querySelectorAll("[data-open-minebox]");
  const closeButtons = drawer.querySelectorAll("[data-close-minebox]");
  const tabs = drawer.querySelectorAll("[data-minebox-tab]");
  const groups = drawer.querySelectorAll("[data-minebox-group]");
  const addButton = drawer.querySelector("[data-add-minebox]");
  const tabsTrack = drawer.querySelector("[data-minebox-tabs-track]");
  const prevTabsButton = drawer.querySelector("[data-minebox-tabs-prev]");
  const nextTabsButton = drawer.querySelector("[data-minebox-tabs-next]");
  const summaryModal = drawer.querySelector("[data-minebox-summary-modal]");
  const openSummaryButton = drawer.querySelector("[data-open-minebox-summary]");
  const closeSummaryButtons = drawer.querySelectorAll("[data-close-minebox-summary]");
  const footerTotalPrice = drawer.querySelector("[data-footer-total-price]");
  const content = drawer.querySelector(".minebox-content");

  const maxWeight = Number(drawer.dataset.maxWeight || 0);
  const minWeight = Number(drawer.dataset.minWeight || 0);
  const minValue = Number(drawer.dataset.minValue || 0);
  const minItems = Number(drawer.dataset.minItems || 0);
  const maxItems = Number(drawer.dataset.maxItems || 0);

  const state = new Map();

  const formatMoney = (cents) => {
    return (cents / 100).toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL"
    });
  };

  const formatWeight = (grams) => {
    if (grams >= 1000) {
      return `${(grams / 1000).toFixed(2).replace(".", ",")}kg`;
    }

    return `${grams}g`;
  };

  function getProductsFromState() {
    const products = [];

    drawer.querySelectorAll(".minebox-product").forEach((el) => {
      const variantId = Number(el.dataset.variantId);
      const qty = Number(el.querySelector("input").value || 0);

      if (qty > 0) {
        products.push({
          variantId,
          title: el.dataset.title,
          quantity: qty,
          price: Number(el.dataset.price),
          weight: Number(el.dataset.weight || 0),
          category: el.dataset.category,
          categoryTitle: el.dataset.categoryTitle,
          categoryMax: Number(el.dataset.categoryMax || 0),
          productMax: Number(el.dataset.productMax || 0)
        });
      }
    });

    return products;
  }

  function canAddToBox(box, product) {
    const nextWeight = box.weight + product.weight;
    const nextQuantity = box.quantity + 1;

    if (maxWeight > 0 && nextWeight > maxWeight) {
      return false;
    }

    if (maxItems > 0 && nextQuantity > maxItems) {
      return false;
    }

    const currentCategoryQty = box.categoryQty[product.category] || 0;

    if (product.categoryMax > 0 && currentCategoryQty + 1 > product.categoryMax) {
      return false;
    }

    const currentProductQty = box.productQty?.[product.variantId] || 0;

    if (product.productMax > 0 && currentProductQty + 1 > product.productMax) {
      return false;
    }

    return true;
  }

  function createEmptyBox(index) {
    return {
      index,
      items: [],
      weight: 0,
      price: 0,
      quantity: 0,
      categoryQty: {},
      productQty: {}
    };
  }

  function packBoxes() {
    const selectedProducts = getProductsFromState();
    const boxes = [createEmptyBox(1)];

    selectedProducts.forEach((product) => {
      for (let i = 0; i < product.quantity; i++) {
        let currentBox = boxes[boxes.length - 1];

        if (!canAddToBox(currentBox, product)) {
          currentBox = createEmptyBox(boxes.length + 1);
          boxes.push(currentBox);
        }

        currentBox.items.push({
          variantId: product.variantId,
          title: product.title,
          price: product.price,
          weight: product.weight,
          category: product.category,
          categoryTitle: product.categoryTitle
        });

        currentBox.weight += product.weight;
        currentBox.price += product.price;
        currentBox.quantity += 1;
        currentBox.categoryQty[product.category] =
          (currentBox.categoryQty[product.category] || 0) + 1;

        currentBox.productQty[product.variantId] =
          (currentBox.productQty[product.variantId] || 0) + 1;
      }
    });

    return boxes.filter((box) => box.quantity > 0);
  }

  function updateProgress() {
    const boxes = packBoxes();
    const currentBox = boxes[boxes.length - 1] || createEmptyBox(1);
    const boxIndex = boxes.length || 1;

    const progressStatus = drawer.querySelector("[data-progress-status]");
    const progressPercent = drawer.querySelector("[data-progress-percent]");
    const progressFill = drawer.querySelector("[data-progress-fill]");
    const progressInfo = drawer.querySelector("[data-progress-info]");

    // Calculate fill percentage based on multiple constraints
    let fillPercent = 0;
    const constraints = [];

    if (maxWeight > 0) {
      const weightPercent = Math.min((currentBox.weight / maxWeight) * 100, 100);
      constraints.push(weightPercent);
    }

    if (maxItems > 0) {
      const itemsPercent = Math.min((currentBox.quantity / maxItems) * 100, 100);
      constraints.push(itemsPercent);
    }

    // Use the most restrictive constraint
    if (constraints.length > 0) {
      fillPercent = Math.max(...constraints);
    } else {
      // Default: show based on a recommended 16 items
      fillPercent = Math.min((currentBox.quantity / 16) * 100, 100);
    }

    // Determine status
    let statusText = "";
    let infoText = "";
    let isFull = false;
    let isWarning = false;

    if (currentBox.quantity === 0) {
      statusText = `Caixa ${boxIndex} - Vazia`;
      infoText = "Adicione produtos para começar";
    } else if (boxes.length > boxIndex || (maxItems > 0 && currentBox.quantity >= maxItems) || (maxWeight > 0 && currentBox.weight >= maxWeight)) {
      // Current box is full and we're on to the next
      statusText = `Caixa ${boxIndex} <span style='color: #22c55e'>✓ Completa!</span>`;
      isFull = true;
      if (boxes.length > boxIndex) {
        infoText = `<strong>Caixa ${boxIndex} cheia!</strong> Novos itens vão para a Caixa ${boxIndex + 1}`;
      } else {
        infoText = "Caixa completa! Pronta para adicionar ao carrinho";
      }
    } else {
      // Calculate remaining
      const remainingItems = maxItems > 0 ? maxItems - currentBox.quantity : null;
      const remainingWeight = maxWeight > 0 ? maxWeight - currentBox.weight : null;

      statusText = `Caixa ${boxIndex} - ${Math.round(fillPercent)}%`;

      const remainingTexts = [];
      if (remainingItems !== null && remainingItems > 0) {
        remainingTexts.push(`<strong>${remainingItems}</strong> itens`);
      }
      if (remainingWeight !== null && remainingWeight > 0) {
        remainingTexts.push(`<strong>${formatWeight(remainingWeight)}</strong>`);
      }

      if (remainingTexts.length > 0) {
        infoText = `Faltam ${remainingTexts.join(" ou ")} para completar`;
      } else {
        infoText = "Continue adicionando produtos";
      }

      // Warning at 80% capacity
      if (fillPercent >= 80) {
        isWarning = true;
      }
    }

    // Update UI
    progressStatus.innerHTML = statusText;
    progressPercent.textContent = `${Math.round(fillPercent)}%`;
    progressFill.style.width = `${fillPercent}%`;
    progressInfo.innerHTML = infoText;

    // Update colors
    progressFill.classList.remove("is-full", "is-warning");
    if (isFull) {
      progressFill.classList.add("is-full");
    } else if (isWarning) {
      progressFill.classList.add("is-warning");
    }
  }

  function updateSummary() {
    updateProgress();
    const boxes = packBoxes();

    const totalItems = boxes.reduce((sum, box) => sum + box.quantity, 0);
    const totalWeight = boxes.reduce((sum, box) => sum + box.weight, 0);
    const totalPrice = boxes.reduce((sum, box) => sum + box.price, 0);

    drawer.querySelector("[data-box-count]").textContent = boxes.length || 1;
    drawer.querySelector("[data-total-items]").textContent = totalItems;
    drawer.querySelector("[data-total-weight]").textContent = formatWeight(totalWeight);
    drawer.querySelector("[data-total-price]").textContent = formatMoney(totalPrice);
    if (footerTotalPrice) footerTotalPrice.textContent = formatMoney(totalPrice);

    const summary = drawer.querySelector("[data-boxes-summary]");
    const warning = drawer.querySelector("[data-minebox-warning]");

    if (!boxes.length) {
      summary.innerHTML = "<p>Nenhum produto selecionado ainda.</p>";
      warning.textContent = "";
      return;
    }

    summary.innerHTML = boxes.map((box) => {
      const valueWarning =
        minValue > 0 && box.price < minValue
          ? `<small class="minebox-alert">Faltam ${formatMoney(minValue - box.price)} para o valor mínimo desta caixa.</small>` 
          : "";

      const itemWarning =
        minItems > 0 && box.quantity < minItems
          ? `<small class="minebox-alert">Adicione mais ${minItems - box.quantity} item(ns) para fechar esta caixa.</small>` 
          : "";

      return `
        <div class="minebox-summary__box">
          <strong>MineBox ${box.index}</strong>
          <span>${box.quantity} itens • ${formatWeight(box.weight)} • ${formatMoney(box.price)}</span>
          ${valueWarning}
          ${itemWarning}
        </div>
      `;
    }).join("");

    if (boxes.length > 1) {
      warning.textContent =
        `Você já configurou ${boxes.length} caixas. Cada nova caixa será separada no carrinho.`;
    } else {
      warning.textContent = "";
    }
  }

  function resetButton() {
    addButton.disabled = false;
    addButton.textContent = "Adicionar MineBox ao carrinho";
  }

  function openSummaryModal() {
    if (!summaryModal) return;
    updateSummary();
    summaryModal.classList.add("active");
    summaryModal.setAttribute("aria-hidden", "false");
  }

  function closeSummaryModal() {
    if (!summaryModal) return;
    summaryModal.classList.remove("active");
    summaryModal.setAttribute("aria-hidden", "true");
  }

  function scrollTabs(direction) {
    if (!tabsTrack) return;
    tabsTrack.scrollBy({
      left: direction * 180,
      behavior: "smooth"
    });
  }

  function setActiveTab(targetTab) {
    tabs.forEach((btn) => {
      btn.classList.toggle("active", btn.dataset.mineboxTab === targetTab);
    });
  }

  function scrollToGroup(targetTab) {
    const group = drawer.querySelector(`[data-minebox-group="${targetTab}"]`);
    if (!group || !content) return;

    content.scrollTo({
      top: group.offsetTop - content.offsetTop,
      behavior: "smooth"
    });
  }

  function updateActiveTabByScroll() {
    if (!content || !groups.length) return;

    const current = Array.from(groups).findLast((group) => {
      return group.offsetTop - content.scrollTop <= 24;
    }) || groups[0];

    if (current) {
      setActiveTab(current.dataset.mineboxGroup);
    }
  }

  openButtons.forEach((button) => {
    button.addEventListener("click", () => {
      drawer.classList.add("active");
      document.body.style.overflow = "hidden";
      updateSummary();
      closeSummaryModal();
    });
  });

  closeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      drawer.classList.remove("active");
      document.body.style.overflow = "";
      closeSummaryModal();
    });
  });

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      setActiveTab(tab.dataset.mineboxTab);
      tab.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      scrollToGroup(tab.dataset.mineboxTab);
    });
  });

  if (prevTabsButton) {
    prevTabsButton.addEventListener("click", () => scrollTabs(-1));
  }

  if (nextTabsButton) {
    nextTabsButton.addEventListener("click", () => scrollTabs(1));
  }

  if (content) {
    content.addEventListener("scroll", updateActiveTabByScroll);
  }

  if (openSummaryButton) {
    openSummaryButton.addEventListener("click", openSummaryModal);
  }

  closeSummaryButtons.forEach((button) => {
    button.addEventListener("click", closeSummaryModal);
  });

  drawer.addEventListener("click", (event) => {
    const product = event.target.closest(".minebox-product");
    if (!product) return;

    const input = product.querySelector("input");
    let value = Number(input.value || 0);

    if (event.target.matches("[data-minebox-plus]")) {
      value += 1;
    }

    if (event.target.matches("[data-minebox-minus]")) {
      value = Math.max(0, value - 1);
    }

    input.value = value;
    updateProgress(); // Real-time progress update
    updateSummary();
  });

  addButton.addEventListener("click", async () => {
    const boxes = packBoxes();

    if (!boxes.length) {
      alert("Escolha pelo menos um produto para montar sua MineBox.");
      return;
    }

    for (const box of boxes) {
      if (minValue > 0 && box.price < minValue) {
        alert(`A MineBox ${box.index} ainda não atingiu o valor mínimo.`);
        return;
      }

      if (minItems > 0 && box.quantity < minItems) {
        alert(`A MineBox ${box.index} ainda não atingiu a quantidade mínima.`);
        return;
      }

      if (minWeight > 0 && box.weight < minWeight) {
        alert(`A MineBox ${box.index} ainda não atingiu o peso mínimo.`);
        return;
      }
    }

    const items = [];

    boxes.forEach((box) => {
      const grouped = {};

      box.items.forEach((item) => {
        if (!grouped[item.variantId]) {
          grouped[item.variantId] = {
            id: item.variantId,
            quantity: 0,
            properties: {
              "_minebox": "true",
              "MineBox": `Caixa ${box.index}`,
              "Peso da caixa": formatWeight(box.weight),
              "Valor da caixa": formatMoney(box.price)
            }
          };
        }

        grouped[item.variantId].quantity += 1;
      });

      Object.values(grouped).forEach((item) => {
        items.push(item);
      });
    });

    addButton.disabled = true;
    addButton.textContent = "Adicionando...";

    try {
      const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ items })
      });

      if (!response.ok) throw new Error("Erro ao adicionar");

      window.location.href = "/cart";
    } catch (error) {
      alert("Não foi possível adicionar a MineBox ao carrinho.");
      resetButton();
    }
  });

  updateSummary();
  updateActiveTabByScroll();
});
